import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useBooking } from "@/App";

export default function MobileCta({ hidden }) {
  const { openBooking } = useBooking();
  if (hidden) return null;
  return (
    <motion.div
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden px-4 pb-4 pt-2 bg-gradient-to-t from-ivory via-ivory/95 to-transparent"
      data-testid="mobile-sticky-cta"
    >
      <motion.button
        whileTap={{ scale: 0.97 }}
        onClick={openBooking}
        data-testid="mobile-sticky-book-button"
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-forest text-ivory px-6 py-4 text-sm font-bold tracking-wide shadow-hover"
      >
        BOOK FREE DISCOVERY CALL <ArrowRight size={16} />
      </motion.button>
    </motion.div>
  );
}
